import { type JSX, ReactNode } from "react";

import Grid from "@mui/material/Grid";
import { ConfigurationTreeItemTypeUnion } from "@plansoft-configuration-renderer/components";

export type ConfigurationTreeItemLabelProps = ConfigurationTreeItemTypeUnion & {
  label: ReactNode;
  debug: ReactNode;
  completeness: ReactNode;
};
export function CustomConfigurationTreeItemLabel(
  props: ConfigurationTreeItemLabelProps,
): JSX.Element {
  const { label, debug, completeness } = props;

  return (
    <Grid
      container
      columnSpacing={0.25}
      sx={{
        alignItems: "center",
      }}
    >
      <Grid sx={{ mr: 2 }}>{completeness}</Grid>
      <Grid>{label}</Grid>
      <Grid sx={{ transform: "scale(0.8) translateX(-7.5%)", height: "24px" }}>
        {debug}
      </Grid>
    </Grid>
  );
}
